module.exports = __webpack_public_path__ + "img/payment_icon_gopay.67bbc9be.png";